<template>
  <div>
    <b-btn variant="secondary" @click="$bvModal.show('print-modal')" style="float: right;" v-if="pass">Print Pass</b-btn>

      <b-modal id="print-modal" title="Print Pass" hide-footer ref="print-modal">
        <PrintModalContents v-if="pass" :currentPass="pass" ref="print-modal-contents" />

        <b-button class="mt-2 print-button" variant="outline-primary" @click="print">Print</b-button>
        <br />
        <div id="action-buttons">
          <b-button class="mt-2" variant="outline-secondary" @click="$refs['print-modal'].hide()">Close</b-button>
          <b-button class="mt-2" variant="outline-primary" @click="confirmPrint">RFID Scan</b-button>
        </div>
      </b-modal>

    <PassForm v-if="pass" :pass="pass" :submit="savePass" isEditing />
    <div v-else id="edit-spinner">
      <b-spinner></b-spinner> 
    </div>
  </div>
</template>

<script>
import PassForm from './common/PassForm';
import api from '../api';
import PrintModalContents from './PrintModalContents.vue';

export default {
  components: {
    PassForm,
    PrintModalContents
  },
  data() {
    return {
      pass: null
    };
  },
  mounted() {
    this.getPass();
  },
  methods: {
    async getPass() {
      const passId = this.$route.params.passId;
      const pass = await api.getPassById(passId);
      this.pass = pass.data.ret_msg;
    },
    async savePass(data, passId) {
      await api.editPass(passId, data);
    },
    async confirmPrint() {
      const passId = this.pass.id;
      await api.setPassToPrinted(passId);
      this.pass.is_printed = true;
      this.$bvModal.hide('print-modal')
    },
    print() {
      window.print();
    },
  },
}
</script>

<style scoped>
#edit-spinner {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

#action-buttons {
  float: right;
}

.create-pass-button {
  float: right;
}

.print-button {
  margin: 0 auto;
  display: block;
}

</style>


// WEBPACK FOOTER //
// src/components/EditPass.vue